import axios from "axios";
import React, { useEffect, useState } from "react";
import { SingleCoin } from "../config/api";
import { CurrencyState } from "../Context";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import Blob from '../assets/blob.png';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

import bitcoinIcon from '../assets/bitcoin.svg';
import ethereumIcon from '../assets/ethereum.svg';
import binanceCoinIcon from '../assets/binance.svg';
import rippleIcon from '../assets/xrp.svg';



function Overview() {

    document.title = "Overview";

    const [id, setId] = useState('bitcoin');
    const [coinId, setCoinId] = useState('bitcoin');
    const [coin, setCoin] = useState();
    const { currency, symbol } = CurrencyState();
    const [period, setPeriod] = useState(1);

    const fetchCoin = async () => {
        const { data } = await axios.get(SingleCoin(coinId));
        setCoin(data);
    };


    useEffect(() => {
        fetchCoin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coinId, currency]);


    const handleCoinClick = (id) => {
        setCoinId(id);
    };

    const btcClicked = () => {
        handleCoinClick('bitcoin');
    };

    const ethClicked = () => {
        handleCoinClick('ethereum');
    };

    const bnbClicked = () => {
        handleCoinClick('binancecoin');
    };

    const xrpClicked = () => {
        handleCoinClick('ripple');
    };

    //Change chart period when a user clicks the period

    const handleChartSelected = (id) => {
        setPeriod(id);
    };

    const dayChart = () => {
        handleChartSelected(1);
    };

    const weekChart = () => {
        handleChartSelected(7);
    };

    const monthChart = () => {
        handleChartSelected(30);
    };

    const yearChart = () => {
        handleChartSelected(365);
    };

    const performance = [
        {
            name: "Page A",
            price: 4000,
            time: 2400,
            amt: 2400,
        },
        {
            name: "Page B",
            price: 3000,
            time: 1398,
            amt: 2210,
        },
        {
            name: "Page C",
            price: 2000,
            time: 9800,
            amt: 2290,
        },
        {
            name: "Page D",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page E",
            price: 1890,
            time: 4800,
            amt: 2181,
        },
        {
            name: "Page F",
            price: 2390,
            time: 3800,
            amt: 2500,
        },
        {
            name: "Page G",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page H",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page I",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page J",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page K",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page L",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page M",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page N",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page O",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page P",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page Q",
            price: 2000,
            time: 9800,
            amt: 2290,
        },
        {
            name: "Page R",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page S",
            price: 4000,
            time: 2400,
            amt: 2400,
        },
        {
            name: "Page T",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page U",
            price: 2000,
            time: 9800,
            amt: 2290,
        },
        {
            name: "Page V",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page W",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page X",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page Y",
            price: 1890,
            time: 4800,
            amt: 2181,
        },
        {
            name: "Page Z",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
    ];


    if (!coin) return <LinearProgress style={{ backgroundColor: "var(--primary)" }} />;


    return (
        <>
            <Container>
                <Hero>
                    <div className='cash'>
                        <p>Account Value</p>
                        <h1>{symbol}1000.00</h1>
                    </div>
                </Hero>

                <TopAssetsBox>

                    <div className='coins'>
                        <button onClick={btcClicked}><img src={bitcoinIcon} /></button>
                        <button onClick={ethClicked}><img src={ethereumIcon} /></button>
                        <button onClick={bnbClicked}><img src={binanceCoinIcon} /></button>
                        <button onClick={xrpClicked}><img src={rippleIcon} /></button>
                    </div>

                    <Chartbox>

                        <h3>{coin.name}</h3>
                        <h1>{symbol} {coin.market_data.current_price[currency.toLowerCase()].toFixed(2)}</h1>

                        <p>{coin.price_change_percentage_24h < 0 ? (
                            <span className="red">
                                {coin.market_data.price_change_percentage_24h.toFixed(2)}%
                            </span>
                        ) : (
                            <span className="green">
                                {coin.market_data.price_change_percentage_24h.toFixed(2)}%
                            </span>
                        )} over the last day</p>

                        <Chart>
                            <TimelineButtons>
                                <button onClick={dayChart}>Day</button>
                                <button onClick={weekChart}>Week</button>
                                <button onClick={monthChart}>Month</button>
                                <button onClick={yearChart}>Year</button>
                            </TimelineButtons>
                            <ResponsiveContainer width="100%" aspect={6}>
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={performance}
                                    margin={{
                                        top: 10,
                                        right: 0,
                                        left: 0,
                                        bottom: 0,
                                    }}
                                >
                                    <Tooltip contentStyle={{ display: "none" }} cursor={false} />
                                    <Line
                                        type="monotone"
                                        dataKey="price"
                                        stroke="var(--primary)"
                                        strokeWidth="4" dot={{
                                            fill: "var(--primary)",
                                            stroke: "var(--primary-darker)", strokeWidth: 2, r: 3
                                        }}
                                        activeDot={{
                                            fill: "var(--primary)", stroke: "var(--primary-darker)",
                                            strokeWidth: 5, r: 7
                                        }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </Chart>
                    </Chartbox>

                </TopAssetsBox>

                <BundleBox>

                    <div className='bundle'>
                        <button>New Bundle</button>

                        <h2>Invest in multiple assets in one click</h2>

                        <span><Link>Buy Bundle <i class="fa-solid fa-arrow-right"></i></Link></span>

                    </div>

                    <div className='bundle-name'>

                        <h1>ZOKA BUNDLE</h1>

                    </div>

                </BundleBox>

            </Container>

        </>
    )
}

export default Overview

const Container = styled.div`
    justify-content: center;
    align-items: center;
    width: 100%;
    font-family: 

`

const Hero = styled.div`
    height: 20vh;
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    margin-top: 90px;
    margin-bottom: 20px;
    background: var(--primary);
    width: 80%;
    border-radius: 20px;
    
    .cash {
        padding: 20px;
        text-align: center;

        h1 {
            color: #fff;
        }

        p {
            color: #fff;
        }

        span {
            color: #fff;
            font-weight: 600;
        }
    }

`

const BundleBox = styled.div`
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 20px;
    color: var(--primary);

    .bundle {
        width: 60%;
        height: 200px;
        border: 2px solid var(--primary);
        margin-right: 20px;
        border-radius: 20px;
        cursor: pointer;
        color: var(--primary);

        h2 {
            font-size: 24px;
            padding: 20px 0 10px 20px;
        }

        button {
            width: 70px;
            height: 25px;
            margin: 10px 0 0 10px;
            font-size: 10px;
            font-weight: 600;
            color: #fff;
            background-color: var(--primary);
            border: none;
            border-radius: 10px;
        }

        span {
            font-weight: 600;
            padding: 20px 0 0 20px;
            font-size: 14px;
        }

        :hover {
            border: 2px solid var(--primary-darker);
        }
    }

    .bundle-name {
        width: 40%;
        height: 200px;
        background-image: linear-gradient(rgba(255, 246, 246, 0.2),rgba(255, 246, 246, 0.2)),url(${Blob});
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        :hover {
            background-image: linear-gradient(rgba(255, 246, 246, 0.6),rgba(255, 246, 246, 0.6)),url(${Blob});
        }

        h1 {
            color: #333;
            font-size: 40px;
        }

    }

    @media (max-width: 768px) {

        .bundle {
            width: 100%;
        }

        .bundle-name {
            display: none;
        }

    }

`

const TopAssetsBox = styled.div`

    height: 80vh;
    margin: 0 auto;
    margin-bottom: 20px;
    width: 80%;
    border-radius: 10px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    overflow: hidden;
    background-color: var(--background);

    @media (max-width: 768px) {
        height: 60vh;
        width: 100%;
        box-shadow: none;
        border-radius: 0px;
    }

    .coins {
        height: 70px;
        display: flex;
        justify-content: left;
        align-items: center;
        border-bottom: 1px solid var(--primary);
        padding: 20px auto;
        padding-left: 20px;

        @media (max-width: 900px){
            justify-content: center;
            padding-left: 0px;
        }

        button {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: none;
            background-color: transparent;
            font-size: 11px;
            font-weight: 600;
            margin-left: 10px;
            justify-content: center;
            align-items: center;
            display: flex;

            :hover {
                transition: 0.2s ease-in-out;
                box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            }

            @media (max-width: 900px){
                width: 40px;
                height: 40px;
            }
        }

        img {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            opacity: 0.9;

            :hover {
                opacity: 1;
                transition: 0.2s ease-in;
            }

            @media (max-width: 900px){
                width: 30px;
                height: 30px;
            }
        }

    }

`

const Chartbox = styled.div`

    h1 {
        font-size: 46px;
        padding: 0 0 0 30px;
        color: #333;
    }

    h3 {
        padding: 20px 0 0 30px;
        color: #333;
    }

    p {
        padding: 0 0 0 30px;
        font-size: 16px;
        color: #333;
        font-weight: 300;

        span {
            font-weight: bold;
            font-size: 16px;
        }
    }

    @media (max-width: 768px) {

        h1 {
            font-size: 32px;
            padding: 5px 0 0 0;
            text-align: center;
        }

        h3 {
            padding: 10px 0 0 0;
            text-align: center;
        }

        p {
            padding: 5px 0 0 0;
            font-size: 11px;
            text-align: center;
        }

    }

`

const Chart = styled.div`

width: 100%;
height: 500px;
margin-top: 40px;

@media (max-width: 768px) {
    margin-top: 20px;
}

`

const TimelineButtons = styled.div`

    display:flex;
    justify-content: right;
    padding-right: 20px;

    button {
        width: 50px;
        height: 40px;
        border: none;
        font-size: 10px;
        font-weight: bold;
        margin-right: 3px;
        background-color: var(--primary);
        color: #fff;
        border-radius: 5px;
        text-transform: uppercase;

        :hover {
            background-color: var(--primary-darker);
            transition: 0.2s ease-in-out;
        }
    }

    @media (max-width: 768px) {
        justify-content: center;
        margin-bottom: 20px;
        padding-right: 0;
    }


`